import {Component, EventEmitter, HostListener, Input, Output} from '@angular/core';

@Component({
    selector: 'app-basic-display-consent-footer',
    templateUrl: './basic-display-consent-footer.component.html',
    styleUrls: ['./basic-display-consent-footer.component.scss']
})
export class BasicDisplayConsentFooterComponent {
    @Input() displayFinish = false;
    @Input() backButtonDisabled = false;
    @Input() unitMarkedWithQuestion = false;
    @Output() emitContinueEvent = new EventEmitter<void>();
    @Output() emitBackEvent = new EventEmitter<void>();
    @Output() emitCompleteEvent = new EventEmitter<void>();
    @Output() emitQuestionEvent = new EventEmitter<void>();

    innerWidth: any;

    constructor() {
        this.onResize();
    }

    @HostListener('window:resize', ['$event'])
    onResize(): void {
        this.innerWidth = window.innerWidth;
    }

    onNextClick(): void {
        this.emitContinueEvent.emit();
    }

    onBackClick(): void {
        this.emitBackEvent.emit();
    }

    onCompleteClick(): void {
        this.emitCompleteEvent.emit();
    }
}
